$(function () {

    const $form = $('.guest-portal');
    const form = $form[0];

    if (!form) {
        return;
    }

    const guestPortal = {

        init() {

            $('.payment-type').on('change', e => {
                const $target = $(e.currentTarget);
                $("#payment-type-content").find(".tab-pane").removeClass('active').removeClass('show');
                $("#" + $target.val()).addClass('active').addClass('show');
            });

            $('[data-amount]').on('click', e => {
                const $target = $(e.currentTarget);

                let path = '/services/guest_portal/';
                let params = Object.fromEntries(new URLSearchParams(location.search));

                $.ajax({
                    method: "POST",
                    url: path,
                    data: {
                        "amount" : $target.attr('data-amount'),
                        "currencyId" : $target.attr('data-currencyId'),
                        "paymentPlan" : $target.attr('data-paymentPlan'),
                        "paymentSettings" : $target.attr('data-paymentSettings'),
                        "rId" : params.rId,
                        "rhid" : params.rhid,
                        "s_gp" : 'payment_link'
                    }
                })
                    .done(function( msg ) {
                        msg = JSON.parse(msg);
                        if (msg.status) {
                            window.location.href = msg.paymentLink;
                        } else {
                            $('#paymentCreditCard').modal('show');
                            $('#paymentCreditCard').find('.error').removeClass('d-none');
                        }
                    });
            });

            $('#customerIsPassenger').on('change', function () {
                let $passenger = $('.passenger:first').closest('.row');
                $passenger.find('[name="firstName0"]').val($('.customer[name="firstName"]').val());
                $passenger.find('[name="lastName0"]').val($('.customer[name="lastName"]').val());
                $passenger.find('[name="email0"]').val($('.customer[name="email"]').val());
                $passenger.find('[name="phone0"]').val($('.customer[name="phone"]').val());
                $passenger.find('[name="address0"]').val($('.customer[name="address"]').val());
                $passenger.find('[name="city0"]').val($('.customer[name="city"]').val());
            });

            $('.documentType').on('change', function () {
                let documentType = $(this).val();
                let $row = $(this).closest('.passenger-row');
                $row.find('.passportNumber').addClass('d-none');
                $row.find('.identityCardNumber').addClass('d-none');
                $row.find('.' + documentType + 'Number').removeClass('d-none');
            });

            $form.on('submit', function (e) {
                e.preventDefault();
                guestPortal.submit();
            });

        },
        submit() {
            let data = {
                customer: {},
                passengers: []
            };

            $('.customer').each(function () {
                data.customer[$(this).attr('name')] = $(this).val();
            });

            $('.passenger').each(function () {
                let $input = $(this).attr('name');
                let idx = $input.replace(/\D/g, '');
                let name = $input.replace(/[0-9]/g, '');

                if (!data.passengers[idx]) {
                    data.passengers[idx] = {};
                }

                data.passengers[idx][name] = $(this).val();
            });

            let path = '/services/guest_portal/';
            data.rId = $("[name='rId']").val();
            data.rhid = $("[name='rhid']").val();
            data.s_gp = 'update_guests';

            $.post(path, data).then(function (response) {
                response = JSON.parse(response);

                $('.response-output-success').toggleClass('d-none', !response.status);
                $('.response-output-error').toggleClass('d-none', response.status);

                $('.modal-btn').click();

                setTimeout(function () {
                    $('.modal-close').click();
                }, 10000);

                if (response.status !== true) {
                    form.reset();
                }
            });
        }
    }

    guestPortal.init();
});